/**
 * RENEWING — the quantity is an allowance that resets every day at restartHour,
 *   or covers the whole dateRange as a single bucket when renewDaily is false.
 *   The API treats an absent mode as this one, so it is never sent.
 *
 * PER_DAY — a finite quantity for a named date that never resets. One entry per
 *   date, which is what lets a customer buy today for a future day.
 */
export const STOCK_AVAILABILITY_MODES = {
  RENEWING: "RENEWING",
  PER_DAY: "PER_DAY",
};
